<template>
  <div>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.administratorDeletedList.push"
    :query-list="queryList"
    :is-show-store-select="isAdministrator"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
  >
    <v-column-time value="注销时间" field="is_del"/>
    <v-column-avatar label="注销者" avatar-key="del_avatar" nickname-key="del_nickname"/>

    <el-table-column label="ID" prop="id" width="100px"/>
    <v-column-avatar/>
    <el-table-column label="所属门店">
      <template v-slot="{ row }">{{ row.store_names | formatStoreName }}</template>
    </el-table-column>
    <el-table-column label="账号" prop="username"/>
    <el-table-column label="手机号" prop="phone"/>
    <el-table-column label="企业微信号">
      <template v-slot="{ row }">
        <span>{{ row.we_chat }}</span>
      </template>
    </el-table-column>

    <el-table-column label="操作" width="310px">
      <template v-slot="{ row }">
        <v-list-button name="编辑资料" size="large" :to="RouteConfig.administratorEdit.to(row.id)"/>
        <v-list-button name="修改密码"  size="large" :to="RouteConfig.administratorEditPasswordByAdministrator.to(row.id)"/>

        <v-popover>
          <v-popover-item icon="update-type" name="移至门店" :to="RouteConfig.administratorSalaryAdd.to(row.id)"/>
          <v-popover-item icon="view" name="任职记录" @click="openPersonnel(row)"/>
          <v-popover-item icon="restore" name="还原账号" @click="handleRestore(row)" :is-loading="isDeleting[row.id]" message="确认要还原该管路员账号吗？"/>
        </v-popover>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`administrator-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>注销时间</span>
              <span>{{ v.is_del | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>注销操作者</span>
              <v-avatar-nickname
                :value="v.del_avatar"
                :nickname="v.del_nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>被注销者</span>
              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>被注销者 ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>所属门店</span>
              <span>{{ v.store_names | formatStoreName }}</span>
            </div>

            <div class="list-item-detail">
              <span>账号</span>
              <span>{{ v.username }}</span>
            </div>

            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone }}</span>
            </div>

            <div class="list-item-detail">
              <span>企业微信号</span>
              <span>{{ v.we_chat }}</span>
            </div>


            <div class="list-item-button">
              <v-list-button name="编辑资料" size="large" :to="RouteConfig.administratorEdit.to(v.id)"/>
              <v-list-button name="修改密码"  size="large" :to="RouteConfig.administratorEditPasswordByAdministrator.to(v.id)"/>

              <v-popover>
                <v-popover-item icon="update-type" name="移至门店" :to="RouteConfig.administratorSalaryAdd.to(v.id)"/>
                <v-popover-item icon="view" name="任职记录" @click="openPersonnel(v)"/>
                <v-popover-item icon="bin" name="还原账号" @click="handleRestore(v)" :is-loading="isDeleting[v.id]" message="确认要还原该管理员账号吗？"/>
              </v-popover>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>

  </v-table>

  <v-dialog-personnel
    v-model="personnelDialogVisible"
    :administrator-id="personnelDialogAdministratorId"
  />
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index, restore } from '@/api/administrator';
import { getLegalQueryList } from '@/utils/formats';
import VDialogPersonnel from '@/components/VDialogPersonnel/index.vue';

export default {
  name: RouteConfig.administratorDeletedList.name,
  components: {
    VDialogPersonnel,
  },
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    queryList: {
      store_id: '',
      is_asc: 0,
      page: 1,
      size: 8,
      keyword: '',
    },
    isLoading: false,
    isDeleting: false,
    personnelDialogVisible: false,
    personnelDialogAdministratorId: 0,
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, route.query);

      const { ...params } = queryList;
      params.is_del = 1;

      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;

      if (next) next();
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
    },
    openPersonnel(row) {
      this.personnelDialogAdministratorId = row.id;
      this.personnelDialogVisible = true;
    },
    async handleRestore({ id }) {
      if (this.isDeleting) return;

      this.isDeleting = true;
      const { isError } = await restore(id);
      this.isDeleting = false;
      if (isError) return;

      this.load();
    },
  },
};
</script>
